import React from 'react';
import angular from '../../../assets/angular.png';

const Angular = () => (
  <section id="angular">
    <img data-src={angular} alt="Angular" />
    <h2>Angular</h2>
    <p>
      Développé depuis 2014 par <strong>Google</strong><br />
      Apparition du langage <strong>TypeScript</strong> <small>(By Microsoft)</small><br />
      Utilisation massive des décorateurs<br />
      Courbe d'apprentissage abrupte<br />
      Processus de développement plus rapide<br />
      Fonctionnalités de test avancées
    </p>
  </section>
);

export default Angular;
